import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconPaper = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 22,
	viewBox: "0 0 25 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0676 15.7201L11.9953 14.8307L9.72325 12.5444C9.14084 11.9591 9.15235 11.0125 9.74857 10.441L14.8706 5.53677H1.22188C0.591127 5.53677 0.0800781 6.04434 0.0800781 6.66851V20.526C0.0800781 21.1525 0.591127 21.66 1.22188 21.66H14.8568L11.0423 17.8213C10.4576 17.236 10.4714 16.2917 11.0676 15.7201Z",
			fill: "#C0C0C0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8686 19.732L11.9953 14.8301L11.0676 15.7195C10.4713 16.291 10.4598 17.2376 11.0422 17.8229L14.8567 21.6594H16.6154C17.8539 20.8683 16.8686 19.732 16.8686 19.732Z",
			fill: "#959595"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9568 3.20229L21.5673 1.04399C20.9872 0.520418 20.0963 0.534136 19.5323 1.07371L14.873 5.53664L9.7487 10.4408C9.15248 11.0124 9.14097 11.959 9.72338 12.5443L11.9955 14.8306L16.6548 19.5153C16.9103 19.7714 17.0875 20.0983 17.1313 20.455C17.1727 20.8025 16.9932 21.3992 16.5834 21.6576C16.7837 21.6576 17.0737 21.5021 17.2395 21.1455L24.3573 4.77986C24.553 4.222 24.3988 3.60011 23.9568 3.20229Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.6001 9.48001C2.6001 9.13207 2.88216 8.85001 3.2301 8.85001H11.8401C12.188 8.85001 12.4701 9.13207 12.4701 9.48001C12.4701 9.82795 12.188 10.11 11.8401 10.11H3.2301C2.88216 10.11 2.6001 9.82795 2.6001 9.48001Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.81006 13.26C2.81006 12.9121 3.09212 12.63 3.44006 12.63H6.38006C6.728 12.63 7.01006 12.9121 7.01006 13.26C7.01006 13.6079 6.728 13.89 6.38006 13.89H3.44006C3.09212 13.89 2.81006 13.6079 2.81006 13.26Z",
			fill: "white"
		})
	] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_853_87967",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24.36,
			height: 21,
			fill: "white",
			transform: "translate(0.0800781 0.660004)"
		})
	}) })]
});
export default SvgIconPaper;
